"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const TabularFilter_1 = require("../modules/models/TabularFilter");
const FilterItem_vue_1 = __importDefault(require("./FilterItem.vue"));
let FilterPanelInside = class FilterPanelInside extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.auxFilters = 1;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get numAuxFilters() {
        if (this.filters.length === 0 || this.auxFilters == 0)
            this.auxFilters = 1;
        return this.auxFilters;
    }
    removeFilter() {
        this.$emit('removeFilter');
    }
    addRule() {
        this.auxFilters += 1;
    }
    get localFilters() {
        const helper = [...this.filters];
        return helper;
    }
    get tempFilter() {
        return new TabularFilter_1.TabularFilter({
            column: { id: 'hola', label: 'Hola' },
            type: 'starts_with',
            key: '',
            id: -1
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], FilterPanelInside.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], FilterPanelInside.prototype, "filters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], FilterPanelInside.prototype, "columns", void 0);
FilterPanelInside = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { FilterItem: FilterItem_vue_1.default, Plus: lucide_vue_next_1.Plus, Button: bmk_ui_framework_1.Button, Separator: bmk_ui_framework_1.Separator },
    })
], FilterPanelInside);
exports.default = FilterPanelInside;
